import { useEffect, useRef } from "react";
import { renderBrandedQr } from "@/lib/qr";

export const FooterQr = ({ url, label }) => {
  const ref = useRef(null);
  useEffect(() => {
    renderBrandedQr({ url, size: 320 }).then((c) => {
      const el = ref.current; if (!el) return;
      el.width = c.width; el.height = c.height; el.getContext("2d").drawImage(c, 0, 0);
    }).catch(() => {});
  }, [url]);
  return (
    <div data-testid="footer-qr" className="flex items-center gap-4 mt-6">
      <canvas ref={ref} className="h-24 w-24 rounded-sm bg-white p-1 shrink-0" aria-label={`QR code — ${label}`} />
      <div>
        <div className="font-mono-accent text-[10px] uppercase tracking-widest text-white/40">Σκανάρετε</div>
        <div className="text-sm text-white/80 leading-snug mt-1">{label}</div>
        <div className="font-mono-accent text-[10px] text-accent mt-1">{url.replace(/^https?:\/\//, "")}</div>
      </div>
    </div>
  );
};
